import { Box, Typography } from "@mui/material";

import { Notification } from "../../../services/notifications/notifications-interface";
import NotificationCard from "./NotificationCard";
import { NotificationCardContainerStyle } from "./Notification.style";
import NotificationNullState from "./Notification-null-state";
import React from "react";

type Props = {
  notifications: Notification[]
  handleCTA: (notification: Notification) => void;
  getIcon: (notification: Notification) => void;

}

const PastNotification = (props: Props) => {
  const { notifications, handleCTA, getIcon } = props;

  return (
    <>
      <Box sx={NotificationCardContainerStyle}>
        <Typography variant="body1" fontWeight={600}>Past Notifications</Typography>
        {notifications.length === 0 && <NotificationNullState title={"No past notifications"}/>}
        {notifications.map((notification: Notification, index: number)=>(
          <NotificationCard
            key={index}
            notification={notification}
            handleCTA={handleCTA}
            getIcon={getIcon}
          />
        ))}
      </Box>
    </>
  );
};

export default PastNotification;
